module.exports = __webpack_public_path__ + "app-engine.5fac70.svg";